import PageLayout from "@/components/PageLayout";
import PageHeader from "@/components/PageHeader";
import { motion } from "framer-motion";
import { Phone, Mail, MapPin } from "lucide-react";
import SEO from "@/components/SEO";

export default function YhteystiedotPage() {
  return (
    <PageLayout>
      <SEO title="Yhteystiedot — Kuntosali Takomo" description="Kuntosali Takomon yhteystiedot. Salit Jokelassa ja Kellokoskella. Puhelin, sähköposti ja osoitteet. Ota yhteyttä!" path="/yhteystiedot" />
      <PageHeader title="Yhteystiedot" subtitle="Ota yhteyttä — autamme mielellämme!" />

      <section className="section-padding">
        <div className="container mx-auto max-w-4xl">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="bg-card-premium rounded-lg p-8">
              <h2 className="font-display text-2xl font-bold text-foreground mb-2">Ota yhteyttä</h2>
              <div className="divider-primary mb-6" />
              <div className="space-y-4">
                <a href="tel:0443394158" className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors">
                  <Phone size={18} className="text-primary" /> 044 3394158
                </a>
                <a href="tel:0449980593" className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors">
                  <Phone size={18} className="text-primary" /> 044 9980593
                </a>
                <a href="mailto:info@kuntotakomo.fi" className="flex items-center gap-3 text-foreground/80 hover:text-primary transition-colors">
                  <Mail size={18} className="text-primary" /> info@kuntotakomo.fi
                </a>
              </div>
            </motion.div>

            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }} className="bg-card-premium rounded-lg p-8">
              <h2 className="font-display text-2xl font-bold text-foreground mb-2">Sijainnit</h2>
              <div className="divider-primary mb-6" />
              <div className="space-y-6">
                <div className="flex items-start gap-3">
                  <MapPin size={18} className="text-primary mt-1 shrink-0" />
                  <div>
                    <h3 className="font-display text-lg font-semibold text-foreground">Jokela</h3>
                    <p className="text-muted-foreground text-sm">Keskustie 2, Jokela</p>
                    <p className="text-primary text-sm font-semibold mt-1">24/7</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <MapPin size={18} className="text-primary mt-1 shrink-0" />
                  <div>
                    <h3 className="font-display text-lg font-semibold text-foreground">Kellokoski</h3>
                    <p className="text-muted-foreground text-sm">Vanha Valtatie 195, Kellokoski</p>
                    <p className="text-primary text-sm font-semibold mt-1">05:00–22:00</p>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="rounded-lg overflow-hidden aspect-[4/3]">
              <iframe
                title="Jokela"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1933.5!2d24.9915!3d60.55!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x468e0!2sKeskustie+2%2C+Jokela!5e0!3m2!1sfi!2sfi!4v1"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </motion.div>
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: 0.1 }} className="rounded-lg overflow-hidden aspect-[4/3]">
              <iframe
                title="Kellokoski"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1933.5!2d25.0415!3d60.55!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x468e0!2sVanha+Valtatie+195%2C+Kellokoski!5e0!3m2!1sfi!2sfi!4v1"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </motion.div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
